export type EditorZoomShortcutDirection = 'in' | 'out';
export type EditorZoomShortcutTarget = 'canvas' | 'timeline';

interface HoverTarget {
  matches: (selector: string) => boolean;
}

interface GetEditorZoomShortcutTargetParams {
  canvas: HoverTarget | null;
  timeline: HoverTarget | null;
}

interface GetEditorZoomShortcutDirectionParams {
  key: string;
  shiftKey: boolean;
}

export const getEditorZoomShortcutDirection = (
  params: GetEditorZoomShortcutDirectionParams,
): EditorZoomShortcutDirection | null => {
  if (params.key === '+' || params.key === '=') {
    return 'in';
  }

  if (params.key === '-') {
    return 'out';
  }

  return null;
};

export const getEditorZoomShortcutTarget = ({
  canvas,
  timeline,
}: GetEditorZoomShortcutTargetParams): EditorZoomShortcutTarget | null => {
  if (timeline?.matches(':hover')) {
    return 'timeline';
  }

  if (canvas?.matches(':hover')) {
    return 'canvas';
  }

  return null;
};
